@if (pageLoading1) {
<div class="loader text-center">
	<img src="../../assets/img/loading.gif" />
	<p style="color: black;font-weight: bolder;">Loading...</p>
</div>
}
@if ((!uId && navbar.user?.tms_access?.create_event) || (uId && navbar.user?.tms_access?.edit_event)) {
<form [formGroup]="moduleForm" (ngSubmit)="saveData()" #modform="ngForm">
	<div class="row mb-3">
		<div class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
			<div class="input-group">
				<div class="form-floating">
					<input class="form-control" [ngClass]="{'is-invalid':showError('date')}" placeholder=""
						formControlName="date" ngbDatepicker id="date" #date="ngbDatepicker" [minDate]="minDate"
						[container]="'body'" />
					<label for="date">Date*</label>
				</div>
				<button class="btn btn-outline-secondary" (click)="date.toggle()" type="button">
					<fa-icon [icon]="['fas', 'calendar-week']"></fa-icon>
				</button>
			</div>
			@if (showError('date')) {
			<p class="text-danger">
				@if (f.date.errors?.required) {
				Required
				}
				@if (f.date.errors?.ngbDate) {
				Invalid
				}
				@if (f.date.errors?.incorrect) {
				{{customError.date}}
				}
			</p>
			}
		</div>
		<div class="col-lg-9 col-md-9 col-sm-12 col-xs-12">
			<div class="form-floating">
				<input class="form-control" [ngClass]="{'is-invalid':showError('name')}" id="name"
					formControlName="name" placeholder="" />
				<label for="name">Event*</label>
			</div>
			@if (showError('name')) {
			<p class="text-danger">
				@if (f.name.errors?.required) {
				Required
				}
				@if (f.name.errors?.incorrect) {
				{{customError.name}}
				}
			</p>
			}
		</div>
	</div>
	<div class="row mb-3">
		<div class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
			<div class="ng-select-material">
				<ng-select [items]="navbar.departmentList" bindValue="id" bindLabel="name"
					placeholder="Presenter Departments" formControlName="presenter_departments"
					id="presenter_departments" appendTo="body" (change)="presenter_getUserList()" appearance="outline"
					[multiple]="true">
				</ng-select>
			</div>
		</div>
		<div class="col-lg-9 col-md-9 col-sm-12 col-xs-12">
			<div class="ng-select-material">
				<ng-select [items]="presenter_userList" bindValue="dec_id" bindLabel="full_name"
					placeholder="Presenter Users" formControlName="presenter_users" id="presenter_users" appendTo="body"
					appearance="outline" [multiple]="true" [groupBy]="'department_name'">
				</ng-select>
			</div>
		</div>
	</div>
	@if (uId) {
	<div class="row mb-3">
		<div class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
			<div class="ng-select-material">
				<ng-select [items]="navbar.departmentList" bindValue="id" bindLabel="name"
					placeholder="Attendee Departments" formControlName="departments" id="departments" appendTo="body"
					(change)="getUserList()" appearance="outline" [multiple]="true">
				</ng-select>
			</div>
		</div>
		<div class="col-lg-9 col-md-9 col-sm-12 col-xs-12">
			<div class="ng-select-material">
				<ng-select [items]="userList" bindValue="dec_id" bindLabel="full_name" placeholder="Attendee Users"
					formControlName="users" id="users" appendTo="body" appearance="outline" [multiple]="true"
					[groupBy]="'department_name'">
				</ng-select>
			</div>
		</div>
	</div>
	}
	<div class="row mb-3">
		<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
			<button type="submit" class="btn btn-sm btn-primary me-1">
				@if (showLoader) {
				<fa-icon [icon]="['fas', 'spinner']" animation="spin"></fa-icon>
				}@else {
				<fa-icon [icon]="['fas', 'save']"></fa-icon>
				}
				Submit
			</button>
			<button type="button" class="btn btn-sm btn-secondary" (click)="clearForm();">
				Cancel
			</button>
		</div>
	</div>
</form>
}@else {
<div>
	<h3 class="text-center">You don't have access to this section.</h3>
</div>
}